module.exports = __webpack_public_path__ + "static/media/calm_neutral.b43fbb53.svg";